import { capacity } from "@founderdeck/core";
import type { Task } from "../lib/api";

export function CapacityBar({ tasks }: { tasks: Task[] }) {
  const c = capacity(tasks.map((t) => ({ estMin: t.estMin, status: t.status })));
  const usedH = Math.round(c.usedMin / 6) / 10;
  return (
    <div className="capbar">
      <div className="capfill">
        <i className={c.over ? "over" : ""} style={{ width: `${c.pct}%` }} />
      </div>
      <span className="caplab">
        <b>{usedH}h</b> planned / {c.capMin / 60}h{c.over ? " · over capacity" : ""}
      </span>
    </div>
  );
}
